import { EventsApi } from "@/api/events";
import { CancelEventRequest } from "@/api/events/types";
import { useUIStore } from "@/stores";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useCancelEvent = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: CancelEventRequest) => EventsApi.cancel(body),
    onMutate: () => {
      closeModal();
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: (_, { eventId }) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.EVENT, eventId],
      });
      notify("Event cancelled!", { type: "success" });
    },
  });

  return { cancelEvent: mutate, isCancelEventLoading: isPending };
};
